import script from "./CanvasControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasControls.vue?vue&type=script&setup=true&lang=ts"

import "./CanvasControls.vue?vue&type=style&index=0&id=5be6b1e0&lang=scss"

const __exports__ = script;

export default __exports__